import { Checkbox as ChakraCheckbox } from "@chakra-ui/react"
import { forwardRef } from "react"

interface CheckboxProps extends Omit<React.ComponentProps<typeof ChakraCheckbox.Root>, 'children'> {
  children?: React.ReactNode
  variant?: "outline" | "solid" | "subtle"
  size?: "xs" | "sm" | "md" | "lg"
  colorPalette?: "gray" | "red" | "orange" | "yellow" | "green" | "teal" | "blue" | "cyan" | "purple" | "pink"
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ children, ...props }, ref) => {
    return (
      <ChakraCheckbox.Root {...props}>
        <ChakraCheckbox.HiddenInput ref={ref} />
        <ChakraCheckbox.Control>
          <ChakraCheckbox.Indicator />
        </ChakraCheckbox.Control>
        {children && <ChakraCheckbox.Label>{children}</ChakraCheckbox.Label>}
      </ChakraCheckbox.Root>
    )
  }
)

Checkbox.displayName = "Checkbox"
